<ng-template ixPageHeader>
  <ix-page-title-header>
    <button *ngIf="canAdd" mat-button color="primary" ixTest="add-vm" (click)="doAdd()">
      {{ 'Add' | translate }}
    </button>
  </ix-page-title-header>
</ng-template>

<div *ngIf="hasVirtualizationSupport" class="vm-summary">
  <p *ngIf="availableMemory">
    <strong>{{ memTitle | translate }}</strong> {{ availableMemory }} -
    {{ memWarning | translate }}
  </p>
</div>

<ix-entity-table [title]="title" [conf]="this"></ix-entity-table>
